import { UiControl } from './ui-control.model';
import { OnChangeArgs } from '../../components/select-field/select-field.component';
import { FileRestrictions, FileInfo } from "@progress/kendo-angular-upload";

export class UploadControl extends UiControl<Array<any> | null> {

  data: Array<any> = [];
  allowMultiple: boolean;

  constructor(id: string, label: string, values: Array<any>);
  constructor(...arr: any[]) {
    var id = arr[0];
    var label = arr[1];
    var data: Array<any> = [];


    //data.push(values);

    super(id, label, data, true);

    this.className = "UploadControl";
  }
}
